import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {HeadTitle} from '@shared';
function _createMdxContent(props) {
  const _components = {
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(HeadTitle, {
      title: "Terms and Conditions"
    }), "\n", _jsx(_components.h1, {
      children: "Terms and Conditions"
    }), "\n", _jsx(_components.h2, {
      children: "Welcome to CNA Classes For Me!"
    }), "\n", _jsx(_components.p, {
      children: "These terms and conditions outline the rules and regulations for the use of CNA\nClasses For Me's Website."
    }), "\n", _jsx(_components.p, {
      children: "By accessing this website we assume you accept these terms in full. Do not\ncontinue to use CNA Classes For Me's website if you do not accept all of the\nterms and conditions stated on this page."
    }), "\n", _jsx(_components.p, {
      children: "The following terminology applies to these Terms and Conditions, Privacy Policy\nand any or all Agreements: \"Client\", \"You\" and \"Your\" refers to you, the person\naccessing this website and accepting the Company's terms of service. \"The\nCompany\", \"Ourselves\", \"We\", \"Our\" and \"Us\", refers to our Company. \"Party\",\n\"Parties\", or \"Us\", refers to both the Client and ourselves, or either the\nClient or ourselves. Any use of the above terminology or other words in the\nsingular, plural, capitalization and/or he/she or they, are taken as\ninterchangeable and therefore as referring to same."
    }), "\n", _jsx(_components.h2, {
      children: "Cookies"
    }), "\n", _jsxs(_components.p, {
      children: ["We employ the use of cookies. By using CNA Classes For Me's website you consent\nto the use of cookies in accordance with our ", _jsx("a", {
        href: "/privacy",
        children: "Privacy\nPolicy"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Most of the modern day interactive web sites use cookies to enable us to\nretrieve user details for each visit. Cookies are used in some areas of our site\nto enable the functionality of this area and ease of use for those people\nvisiting."
    }), "\n", _jsx(_components.h2, {
      children: "License"
    }), "\n", _jsx(_components.p, {
      children: "Unless otherwise stated, CNA Classes For Me and/or it's licensors own the\nintellectual property rights for all material on CNA Classes For Me. All\nintellectual property rights are reserved. You may view and/or print pages from\ncnaclassesforme.com for your own personal use subject to restrictions set in\nthese terms and conditions."
    }), "\n", _jsx(_components.p, {
      children: "You must not:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Republish material from cnaclassesforme.com;"
      }), "\n", _jsx(_components.li, {
        children: "Sell, rent or sub-license material from cnaclassesforme.com;"
      }), "\n", _jsx(_components.li, {
        children: "Reproduce, duplicate or copy material from cnaclassesforme.com;"
      }), "\n", _jsx(_components.li, {
        children: "Redistribute content from CNA Classes For Me unless content is specifically\nmade for redistribution."
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Inline Frames"
    }), "\n", _jsx(_components.p, {
      children: "Without prior approval and express written permission, you may not create frames\naround our Web pages or use other techniques that alter in any way the visual\npresentation or appearance of our Web site."
    }), "\n", _jsx(_components.h2, {
      children: "Disclaimer"
    }), "\n", _jsx(_components.p, {
      children: "To the maximum extent permitted by applicable law, we exclude all\nrepresentations, warranties and conditions relating to our website and the use\nof this website (including, without limitation, any warranties implied by law in\nrespect of satisfactory quality, fitness for purpose and/or the use of\nreasonable care and skill). Nothing in this disclaimer will:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "limit or exclude our or your liability for death or personal injury resulting\nfrom negligence;"
      }), "\n", _jsx(_components.li, {
        children: "limit or exclude our or your liability for fraud or fraudulent\nmisrepresentation;"
      }), "\n", _jsx(_components.li, {
        children: "limit any of our or your liabilities in any way that is not permitted under\napplicable law; or"
      }), "\n", _jsx(_components.li, {
        children: "exclude any of our or your liabilities that may not be excluded under\napplicable law."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "The limitations and exclusions of liability set out in this Section and\nelsewhere in this disclaimer: (a) are subject to the preceding paragraph; and\n(b) govern all liabilities arising under the disclaimer or in relation to the\nsubject matter of this disclaimer, including liabilities arising in contract, in\ntort (including negligence) and for breach of statutory duty."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
